import { useContext, useEffect, useState } from "react"
import axios from "axios"
import { Button } from "../../../designSystems/components/Button"
import { Container } from "./style"
import { RegisterPageContext } from "../../../context/RegisterPageContext"
import { CongratsProps } from "../../../models/CongratsProps"
import { useNavigate } from "react-router"
import { GlobalContext } from "../../../context/GlobalContext"
import { getCongratulations } from "../../../api/solidarity-bank"
import { getAboutInitiative } from "../../../api/about-initiative"
import { AdminPageContext } from "../../../context/AdminPageContext"
import { InitiativeSummaryCard } from "../InitiativeSummaryCard"
import { cityActionsOptions, districtLocaleOptions } from "../../../api/utils/fieldsOptions"

const parseField = (value: any, fallback: any = '') => {
    if (value == null || value === '') return fallback
    if (typeof value === 'object') return value
    try {
        return JSON.parse(value)
    } catch {
        return fallback
    }
}

const toNumber = (value: any): number | undefined => {
    if (value === undefined || value === null || value === '') return undefined
    const parsed = Number(value)
    return Number.isNaN(parsed) ? undefined : parsed
}

export const CongratsContent = (): JSX.Element => {
    const [dataPage, setDataPage] = useState<CongratsProps>({})

    const { setCurrentPage } = useContext(RegisterPageContext)
    const { setIsEdition, isEdition } = useContext(AdminPageContext)
    const { setIsLoading, setDataToast, getErrorMessage, vertifyAuthenticatedRedirect, userId, pathnameIsAdmin } = useContext(GlobalContext)

    const navigate = useNavigate()

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = (): void => {
        setIsLoading(true)
        const params = pathnameIsAdmin() ? { user_id: userId } : null

        axios.all([
            getCongratulations(params),
            getAboutInitiative(params),
        ]).then((response: any) => {
            setIsLoading(false)

            const congratsList = response[0]?.data?.data || []
            const aboutList = response[1]?.data?.data || []
            const responseData: CongratsProps = congratsList[0] || {}
            const aboutData = aboutList[0] || {}

            if (!congratsList.length && !aboutList.length) return

            const cityName = cityActionsOptions.filter(item => item.value === responseData.cityActions)[0]?.text || ''
            let districtName = ''
            const districtLocale = parseField(responseData?.districtLocale, [])

            if (districtLocale?.length) {
                districtName = districtLocaleOptions
                    .filter(item => districtLocale.includes(item.value as number))
                    .map(d => d.text || '')
                    .join(', ')
            }

            setDataPage({
                title: responseData.initiativeName,
                ods: parseField(responseData.ods, []),
                thematics: parseField(responseData.areasExpertise, []),
                description: responseData.initiativeDescription,
                offerTerritory: parseField(responseData.offerTerritoryAvailable, []),
                offerTerritoryOthers: parseField(responseData.offerTerritoryOthers, []),
                providers: parseField((responseData as any).providersAvailable, []),
                providersOthers: parseField((responseData as any).providersAvailableOthers, []),
                localization: responseData.cityActions === 1 ? `${cityName} - ${districtName}` : `${cityName}`,
                networks: parseField(aboutData.networks ?? responseData.networks, []),
                email: aboutData.email ?? responseData.email,
                facebook: aboutData.facebook ?? responseData.facebook,
                instagram: aboutData.instagram ?? responseData.instagram,
                linkedin: aboutData.linkedin ?? responseData.linkedin,
                tiktok: aboutData.tiktok ?? responseData.tiktok,
                website: aboutData.website ?? responseData.website,
                youtube: aboutData.youtube ?? responseData.youtube,
                logo: responseData.logo,
                yearFoundation: aboutData.yearFoundation ?? responseData.yearFoundation,
                motivatingPublic: toNumber(aboutData.motivatingPublic ?? responseData.motivatingPublic),
                socialImpactDimension: toNumber(aboutData.socialImpactDimension ?? responseData.socialImpactDimension),
                socialImpactDimensionOther: aboutData.socialImpactDimensionOther ?? responseData.socialImpactDimensionOther,
            })
        }).catch(err => {
            setIsLoading(false)
            const textError = err.response?.data?.message === 'Unauthorized' ? 'Erro ao buscar informações' : getErrorMessage(err.response?.data?.message)
            setDataToast({ show: true, text: textError })
            if (vertifyAuthenticatedRedirect(err.response?.data?.message)) {
                goToPage('/')
            }
        })
    }

    const goToPage = (path: string): void => {
        navigate(path)
    }

    return (
        <Container>
            <div className="row">
                <div className="col-md-12 flex-cc">
                    <div className="conclusion">
                        <div className="msg">
                            <div className="title">Parabéns!</div>
                            <div className="description">
                                Você acabou de adicionar uma iniciativa no mapa da PerifaSul 2050!
                                Seu card aparecerá desta forma no mapa:
                            </div>
                        </div>

                        <div className="flex-cc">
                            <InitiativeSummaryCard dataPage={dataPage} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-footer">
                <hr />
                <div className="btn-actions f-right">
                    <Button
                        text="Voltar à edição"
                        className="radius-100 btn-gray mr-32"
                        onClick={() => setCurrentPage('solidarity-bank')}
                    />
                    <Button
                        type="submit"
                        text="Concluir"
                        className="radius-100"
                        onClick={() => isEdition ? setIsEdition(!isEdition) : goToPage('/admin')}
                    />
                </div>
            </div>
        </Container>
    )
}
